import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import CourseListing from './CourseListing';
import Loader from './Loader';

class CourseList extends Component {

  renderListings() {
    const { store } = this.props;
    if (!store.loadedPortalData.get()) {
      store.fetchAttendances();
      return <li className="list-group-item">Loading courses... <Loader /></li>;
    }    
    if (!store.courses) {
      return <li className="list-group-item font-weight-light small font-italic">No course registrations found.</li>;
    }
    const listings = [];
    for (const key in store.courses) {
      listings.push(<CourseListing courseId={key} key={key} />)
    }  
    return listings;
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <h4 className="card-header">
                    My Courses
                    {/*<img
                      alt="" 
                      src="https://kabbalah.com/content/dam/kabbalah/logos/TKC_Monogram_Large_RGB.png"
                      className="rounded float-right image-fluid"
                      width="30px"
                    />*/}
                </h4>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-none d-lg-block font-weight-light font-italic">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-1 text-center">
                          <span className="d-none d-xl-block">Image</span>
                        </div>
                        <div className="col-lg-8">Name</div>
                        <div className="col-lg-3 text-center">Start Date</div>                       
                      </div>
                    </div>
                  </li>
                  {this.renderListings()}
                </ul>
                <div className="card-footer">
                    &nbsp;
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

export default inject('store')(observer(CourseList));



// WEBPACK FOOTER //
// ./src/components/CourseList.js